import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  height: 100%;
  color: white;
  display: grid;
  padding-left: 5px;
  align-items: center;
  font-family: monospace;
`;

const LongLine = styled.div`
  display: grid;
  grid-template-columns: 20% repeat(10, 1fr);
`;
const StatusLine = styled.div`
  display: grid;
  grid-template-columns: 40% repeat(4, 1fr);
`;
const OutputLine = [
  `OUTPUT`,
  ...Array(10)
    .fill(1)
    .map((a, i) => i + 1),
];
const inputValues = [4, 1, 3, 2];
const InputLine = [
  `INPUT`,
  ...Array(10)
    .fill(1)
    .map(() => inputValues[Math.floor(Math.random() * inputValues.length)]),
];

const ConnectionDisplay = () => {
  return (
    <Container>
      <LongLine>
        {OutputLine.map((item) => (
          <div>{item}</div>
        ))}
      </LongLine>
      <LongLine>
        {InputLine.map((item) => (
          <div>{item}</div>
        ))}
      </LongLine>
      <div>Change Input/Attenuat. and Press ENTER</div>
      <StatusLine>
        <div>ATEENUAT.20dB</div>
        <div>6dB</div>
        <div>Auto</div>
        <div>0dB</div>
        <div>L</div>
      </StatusLine>
    </Container>
  );
};

export default ConnectionDisplay;
